import { $findMatchingParent } from '@lexical/utils';
import { $isRootOrShadowRoot, type LexicalNode } from 'lexical';

/**
 * Finds the top-level element containing the given node.
 * Used for determining block type and format.
 */
export function $findTopLevelElement(node: LexicalNode): LexicalNode {
  let topLevelElement =
    node.getKey() === 'root'
      ? node
      : $findMatchingParent(node, (e) => {
          const parent = e.getParent();
          return parent !== null && $isRootOrShadowRoot(parent);
        });

  if (topLevelElement === null) {
    topLevelElement = node.getTopLevelElementOrThrow();
  }
  return topLevelElement;
}
